/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaButtonText/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaButtonText({
  children,
  viewPath = "/DesignSystem/TysiaButton/TysiaButtonText",
  size,
  text = "Label",
  weight = "medium",
  marginLeft = 7,
  marginRight = 7,
  type,
  hovered,
  selected,
  disabled
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtTysiabuttontextColorPrimaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonText.color.primary.hovered'
        })
let dtTysiabuttontextColorPrimarySelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonText.color.primary.selected'
        })
let dtTysiabuttontextColorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonText.color.primary.disabled'
        })
let dtTysiabuttontextColorPrimaryActive = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonText.color.primary.active'
        })
let dtTysiabuttontextColorSecondaryHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonText.color.secondary.hovered'
        })
let dtTysiabuttontextColorSecondarySelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonText.color.secondary.selected'
        })
let dtTysiabuttontextColorSecondaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonText.color.secondary.disabled'
        })
let dtTysiabuttontextColorSecondaryActive = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonText.color.secondary.active'
        })
let dtTysiabuttontextColorCriticalHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonText.color.critical.hovered'
        })
let dtTysiabuttontextColorCriticalSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonText.color.critical.selected'
        })
let dtTysiabuttontextColorCriticalDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonText.color.critical.disabled'
        })
let dtTysiabuttontextColorCriticalActive = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonText.color.critical.active'
        })
let dtTysiabuttontextColorGhostHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonText.color.ghost.hovered'
        })
let dtTysiabuttontextColorGhostSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonText.color.ghost.selected'
        })
let dtTysiabuttontextColorGhostDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonText.color.ghost.disabled'
        })
let dtTysiabuttontextColorGhostActive = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaButtonText.color.ghost.active'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size={size}
 text={text}
 color={type === "primary" && hovered ? dtTysiabuttontextColorPrimaryHovered : type === "primary" && selected ? dtTysiabuttontextColorPrimarySelected : type === "primary" && disabled ? dtTysiabuttontextColorPrimaryDisabled : type === "primary" ? dtTysiabuttontextColorPrimaryActive : type === "secondary" && hovered ? dtTysiabuttontextColorSecondaryHovered : type === "secondary" && selected ? dtTysiabuttontextColorSecondarySelected : type === "secondary" && disabled ? dtTysiabuttontextColorSecondaryDisabled : type === "secondary" ? dtTysiabuttontextColorSecondaryActive : type === "critical" && hovered ? dtTysiabuttontextColorCriticalHovered : type === "critical" && selected ? dtTysiabuttontextColorCriticalSelected : type === "critical" && disabled ? dtTysiabuttontextColorCriticalDisabled : type === "critical" ? dtTysiabuttontextColorCriticalActive : type === "ghost" && hovered ? dtTysiabuttontextColorGhostHovered : type === "ghost" && selected ? dtTysiabuttontextColorGhostSelected : type === "ghost" && disabled ? dtTysiabuttontextColorGhostDisabled : type === "ghost" ? dtTysiabuttontextColorGhostActive : dtColorsWhite}
 weight={weight}
 textOverflow="ellipsis"
 whiteSpace="nowrap"
 marginLeft={size === "normal" ? marginLeft : size === "small" ? marginLeft : marginLeft}
 marginRight={size === "normal" ? marginRight : size === "small" ? marginRight : marginRight}
/>
{children}
</React.Fragment>)
}